import { Cpu, Activity, BarChart2, TrendingUp, Users, FlaskConical } from 'lucide-react'
import { ArrowRight } from 'lucide-react'
import { TELEGRAM_BOT_URL } from '@/lib/constants'
import { useScrollReveal } from '@/hooks/useScrollReveal'

const ENGINES = [
  {
    icon: Cpu,
    name: 'Decision Engine',
    desc: 'Toma la decisión final de cada recomendación, con umbrales mínimos de calidad.',
  },
  {
    icon: FlaskConical,
    name: 'Simulación Monte Carlo',
    desc: 'Miles de simulaciones por partido antes de considerar un pick viable.',
  },
  {
    icon: Activity,
    name: 'Validación & Aprendizaje',
    desc: 'Revisa el histórico y ajusta el sistema con lo que realmente funcionó.',
  },
  {
    icon: TrendingUp,
    name: 'Inteligencia de Mercado',
    desc: 'Lee movimiento de cuotas y consenso de las casas de apuestas.',
  },
  {
    icon: Users,
    name: 'Contexto Humano',
    desc: 'Incorpora señales que los números por sí solos no capturan.',
  },
  {
    icon: BarChart2,
    name: 'Post-Mortem',
    desc: 'Analiza cada pick perdedor para encontrar la causa real, sin excusas.',
  },
]

export function TechSection() {
  const ref = useScrollReveal<HTMLElement>()

  return (
    <section ref={ref} className="max-w-5xl mx-auto px-5 py-20">
      <div className="text-center mb-12 reveal">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-brand mb-2">
          Tecnología
        </p>
        <h2 className="font-display text-3xl sm:text-4xl font-bold">
          Motores reales, no una caja negra
        </h2>
        <p className="mt-3 text-text-dim max-w-lg mx-auto text-sm leading-relaxed">
          Cada motor cumple una función específica. Ninguno decide solo — la recomendación final
          pasa por todos antes de llegar a tu Telegram.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {ENGINES.map((engine, i) => (
          <div
            key={engine.name}
            className="tech-card reveal"
            style={{ transitionDelay: `${i * 80}ms` }}
          >
            <div className="h-10 w-10 rounded-xl bg-brand-soft flex items-center justify-center mb-3">
              <engine.icon className="h-5 w-5 text-brand" />
            </div>
            <h3 className="font-display text-lg font-bold text-brand">{engine.name}</h3>
            <p className="mt-1.5 text-sm text-text-dim leading-relaxed">{engine.desc}</p>
          </div>
        ))}
      </div>

      <div className="cta-strip reveal" style={{ transitionDelay: '300ms' }}>
        <a href={TELEGRAM_BOT_URL} target="_blank" rel="noopener noreferrer" className="btn-brand">
          Ver cómo funciona en acción
          <ArrowRight className="h-4 w-4" />
        </a>
      </div>
    </section>
  )
}
